import mitt, { Emitter } from "mitt";
import { ILocalReceiver } from "@/interfaces/PointInterfaces";

type Events = {
  alert: Alert;
  setCurrentTab: string;
  fetchPointsActivity: string | undefined;
  refetchPayableData: unknown;
  displayAlert: { title?: string; text?: string; type?: string };
  displayEditAlert: { title?: string; text?: string; type?: string };
  setCurrentModalView: string;
  setConfirmationModal: ILocalReceiver;
  transferPointsInsideRoster: Event;
  transferPointsOutsideRoster: Event;
  closeModal: undefined;
};

export interface Alert {
  id?: number;
  type: string;
  message: string;
  description?: string;
  interval?: number;
}
const emitter: Emitter<Events> = mitt<Events>();
const showAlert = (alert: Alert) => {
  emitter && emitter.emit("alert", alert);
};
export default { emitter, showAlert };

export type IEmitter = Emitter<Events>;
